import { createContext } from "react";
import type { EditorVariable } from "./VariableNode";

interface VariableContextValue {
  available: ReadonlyArray<EditorVariable>;
}

export const VariableContext = createContext<VariableContextValue>({
  available: [],
});
